<ng-container *transloco="let t">
  <section class="tamam-dialog">
    <div class="tamam-popup__content">
      @if ((language$ | async) === 'en') {
        <span
          >You will be redirected into Tamam website to proceed with your purchase</span
        >
        <span class="fixed-space-8" aria-hidden="true"></span>

        <span>Please, add your ID Number:</span>
      } @else {
        <span>سيتم توجيهك إلى موقع وطنية لمتابعة عملية الشراء</span>
        <span class="fixed-space-8" aria-hidden="true"></span>

        <span>يرجى إدخال رقم الهوية الوطنية</span>
      }

      <section class="popsy-input" [class.error]="isIdValid() === false">
        <label class="label" [for]="'nationalId'">
          <ng-container>
            <span class="fixed-space-4" aria-hidden="true"></span> </ng-container
          >{{ t('txt_label_id_number') }}</label
        >
        <input
          data-clarity-unmask
          id="nationalId"
          name="nationalId"
          type="text"
          class="field national-id"
          autocomplete="id"
          inputmode="numeric"
          maxlength="10"
          [formControl]="nationalIdFormControl" />
      </section>
      <span class="fixed-space-8" aria-hidden="true"></span>
    </div>
  </section>
</ng-container>
